import { IconLayer } from '@deck.gl/layers';
import { Position } from 'geojson';
import { useMemo } from 'react';

interface UseDeckStationProps {
  position: Position | null; // [lng, lat] de la estación
  idSuffix?: string | null; // para diferenciar por ruta/plan
  station_name?: string | null; // nombre de la estación para tooltip
  onHover?: (info: any) => void; // callback de hover para Deck.gl
}

export const useDeckStation = ({
  position,
  idSuffix,
  station_name,
  onHover,
}: UseDeckStationProps) => {
  const layers = useMemo(() => {
    if (!position) return [];

    const STATION_ICON_URL = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      `<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="18" fill="#ffffff" stroke="#0d47a1" stroke-width="2"/>
        <path d="M12 22 L20 12 L28 22 Z" fill="#0d47a1" />
        <rect x="15" y="22" width="10" height="8" fill="#0d47a1" />
      </svg>`,
    )}`;

    const data = [
      {
        position,
        station_name,
      },
    ];

    const stationLayer = new IconLayer({
      id: `station-layer-${idSuffix ?? 'default'}`,
      data,
      getPosition: (d: any) => d.position,
      getIcon: () => ({
        url: STATION_ICON_URL,
        width: 40,
        height: 40,
        mask: false,
      }),
      getSize: 28,
      sizeUnits: 'pixels',
      billboard: true,
      pickable: true,
      onHover,
    });

    return [stationLayer];
  }, [position, idSuffix, station_name, onHover]);

  return { layers };
};
